import { useContextSelector } from 'use-context-selector';
import { HeaderToolbarContext } from '../context';

export const useToolbarContext = () => {
    const id = useContextSelector(HeaderToolbarContext, (v) => v.id);
    const textLayerId = useContextSelector(HeaderToolbarContext, (v) => v.textLayerId);
    const lock = useContextSelector(HeaderToolbarContext, (v) => v.lock);
    const layerType = useContextSelector(HeaderToolbarContext, (v) => v.layerType);
    const hideCopyBtn = useContextSelector(HeaderToolbarContext, (v) => v.hideCopyBtn);
    const style = useContextSelector(HeaderToolbarContext, (v) => v.style);
    const pickLayerType = useContextSelector(HeaderToolbarContext, (v) => v.pickLayerType);
    const thumbnail = useContextSelector(HeaderToolbarContext, (v) => v.thumbnail);
    const events = useContextSelector(HeaderToolbarContext, (v) => v.events);
    const isIntl = useContextSelector(HeaderToolbarContext, (v) => v.isIntl);
    const onLock = useContextSelector(HeaderToolbarContext, (v) => v.onLock);
    const onSort = useContextSelector(HeaderToolbarContext, (v) => v.onSort);
    const onCopy = useContextSelector(HeaderToolbarContext, (v) => v.onCopy);
    const onDelete = useContextSelector(HeaderToolbarContext, (v) => v.onDelete);
    const beforeDelete = useContextSelector(HeaderToolbarContext, (v) => v.beforeDelete);
    const onCopyBrush = useContextSelector(HeaderToolbarContext, (v) => v.onCopyBrush);
    const onApplyBrush = useContextSelector(HeaderToolbarContext, (v) => v.onApplyBrush);
    const onCopyImageEffect = useContextSelector(HeaderToolbarContext, (v) => v.onCopyImageEffect);
    const role = useContextSelector(HeaderToolbarContext, (v) => v.role);
    return {
        id,
        textLayerId,
        lock,
        layerType,
        pickLayerType,
        hideCopyBtn,
        style,
        thumbnail,
        events,
        isIntl,
        onCopyBrush,
        onApplyBrush,
        onLock,
        onSort,
        onCopy,
        onDelete,
        beforeDelete,
        onCopyImageEffect,
        role,
    };
};
